import { addStyles } from 'ethcss'
import { grid, IStyles} from '../../../theme'

const filesModerationStyles: IStyles = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        ...grid.mt_md
    },
    statusWrapper: {
        ...grid.row, 
        ...grid.normalCenter, 
        ...grid.center,
        gap: 10
    }
}

addStyles(filesModerationStyles)
export default filesModerationStyles
